"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var uniqueId = 0;

exports.default = function () {
  return uniqueId++;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/misc/getUniqueId.js
// module id = 97
// module chunks = 0